import { Permission, Role } from 'appwrite';
import { tablesDB } from '../../services/appwrite/client';

const DATABASE = 'principal';

export type Gender = 'female' | 'male' | 'non_binary' | 'other' | 'prefer_not_to_say';
export type Pronoun = 'he' | 'she' | 'they' | 'other';
export type Modality = 'in_person' | 'virtual' | 'both';
export type RegisteredVia = 'password' | 'google';
export type Disability =
  | 'none'
  | 'total_blindness'
  | 'low_vision'
  | 'hearing'
  | 'motor'
  | 'cognitive'
  | 'communication'
  | 'autism_spectrum'
  | 'mental_health'
  | 'other'
  | 'prefer_not_to_say';

export interface RegistrationInput {
  firstName: string;
  lastName: string;
  displayName: string;
  /** Fecha de nacimiento; se descompone en día/mes/año al guardar. */
  birthDate: Date;
  country: string;
  timezone: string;
  gender: Gender;
  pronoun: Pronoun;
  disability: Disability[];
  accessibilityNotes: string;
  modality: Modality;
  registeredVia: RegisteredVia;
}

/**
 * Crea la fila de perfil de la propia cuenta.
 *
 * A diferencia del resto de la aplicación, esto **no** pasa por
 * `management-command`: en el sitio Jekyll de referencia la fila la crea el
 * cliente directamente, con permisos explícitos por fila (`rowId` es el propio
 * `userId`, y solo esa cuenta puede leerla, actualizarla o borrarla). Se
 * mantiene ese mismo camino para no depender de una acción de backend que hoy
 * no existe.
 */
export async function createOwnProfile(userId: string, input: RegistrationInput): Promise<void> {
  await tablesDB.createRow({
    databaseId: DATABASE,
    tableId: 'profiles',
    rowId: userId,
    data: {
      userId,
      firstName: input.firstName,
      lastName: input.lastName,
      displayName: input.displayName,
      birthDay: input.birthDate.getDate(),
      birthMonth: input.birthDate.getMonth() + 1,
      birthYear: input.birthDate.getFullYear(),
      country: input.country,
      timezone: input.timezone,
      gender: input.gender,
      pronoun: input.pronoun,
      disability: input.disability,
      accessibilityNotes: input.accessibilityNotes || null,
      modality: input.modality,
      registeredVia: input.registeredVia,
    },
    permissions: [
      Permission.read(Role.user(userId)),
      Permission.update(Role.user(userId)),
      Permission.delete(Role.user(userId)),
    ],
  });
}
